import { IServiceBook } from './../../../_models/profile-sections/IServiceBook';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { ToastrService } from 'ngx-toastr';
import { ISpouseOutInfo } from './../../../_models/profile-sections/ISpouseOutInfo';
import { SpouseOutInfoService } from './../../../shared/services/spouse-out-info.service';
import { ISpouseInInfo } from './../../../_models/profile-sections/ISpouseInInfo';
import { SpouseInInfoService } from './../../../shared/services/spouse-in-info.service';
import { ISingleWomenInfo } from './../../../_models/profile-sections/ISingleWomenInfo';
import { SingleWomenInfoService } from './../../../shared/services/single-women-info.service';
import { IDiseaseInfo } from './../../../_models/profile-sections/IDiseaseInfo';
import { DiseaseInfoService } from './../../../shared/services/disease-info.service';
import { DisabledInfoService } from './../../../shared/services/disabled-info.service';
import { IDisabledInfo } from './../../../_models/profile-sections/IDisabledInfo';
import { IProfile } from './../../../_models/account/IProfile';
import { ProfileService } from './../../../shared/services/profile.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ISetting } from 'src/app/_models/cms/ISetting';

@Component({
  selector: 'app-other-details',
  templateUrl: './other-details.component.html',
  styleUrls: ['./other-details.component.css']
})
export class OtherDetailsComponent implements OnInit {
  skeleton: boolean = true;
  profile: IProfile;
  setting: ISetting;
  loading: boolean;

  transferRequest: ITransferRequest;
  transferRequestForm: FormGroup;
  id;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private service: TransferRequestService,
    private profileService: ProfileService,
    private transferRequestService: TransferRequestService,
    private disabledInfoService: DisabledInfoService,
    private diseaseInfoService: DiseaseInfoService,
    private singleWomenInfoService: SingleWomenInfoService,
    private spouseInInfoService: SpouseInInfoService,
    private settingService: SettingService,
    private spouseOutInfoService: SpouseOutInfoService,) { }

  async ngOnInit() {
    this.createTransferRequestForm();

    this.setting = await this.settingService.getSetting();
    this.getProfile();
    if (this.setting) {
      this.transferRequestForm.patchValue({
        financialYearId: this.setting.financialYearId,
        phaseId: this.setting.phaseId
      });
    }
  }

  private getProfile() {
    this.profileService.logged().subscribe((response: IProfile) => {
      if (response) {
        this.profile = response;
        if (this.isValidServiceBook(this.profile)) {
          this.getTransferRequest();
          this.getDisabledInfo();
          this.getDiseaseInfo();
          this.getSingleWomenInfo();
          this.getSpouseInInfo();
          this.getSpouseOutInfo();     
        }
        else {
          this.toastrService.warning('Please furnish complete service details (place, post, tenure and reason of posting) starting from the Date of joining in NVS.');
          this.router.navigate(['/employee/service-book']);
        }
      }
      else {
        this.toastrService.success('you must fill up profile first.');
        this.router.navigate(['/employee/profile']);
      }
    });
  }

  isValidServiceBook(profile: IProfile): boolean {
    if (profile && profile?.serviceBooks) {
      let valid = false;
      var ord_serviceBooks = profile.serviceBooks.sort((a: any, b: any) => b["durationFrom"].localeCompare(a["durationFrom"])).reverse();
      if (ord_serviceBooks[0] && ord_serviceBooks[0].durationFrom == profile.nvsJoiningDate && profile.serviceBooks.filter(x => x.isPresent == true).length == 1) {
        valid = true;
      }
      return valid;
    }
    else {
      return false;
    }
  }

  isValidPresentPlace(profile: IProfile): boolean {
    if (profile && profile?.serviceBooks) {
      let valid = false;
      if (profile.serviceBooks.filter(x => x.isPresent == true).length == 1) {
        valid = true;
      }
      return valid;
    }
    else {
      return false;
    }
  }

  getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
        this.transferRequest = response;
        this.id = this.transferRequest.id;
        this.id = response.id;
        this.setValueTransferRequestFForm();
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  getDisabledInfo() {
    this.disabledInfoService.logged().subscribe((response: IDisabledInfo) => {
      if (response) {
        this.profile.disabledInfos.push(response);
      }
    });
  }
  getDiseaseInfo() {
    this.diseaseInfoService.logged().subscribe((response: IDiseaseInfo) => {
      if (response) {
        this.profile.diseaseInfos.push(response);
      }
    });
  }
  getSingleWomenInfo() {
    this.singleWomenInfoService.logged().subscribe((response: ISingleWomenInfo) => {
      if (response) {
        this.profile.singleWomenInfos.push(response);
      }
    });
  }
  getSpouseInInfo() {
    this.spouseInInfoService.logged().subscribe((response: ISpouseInInfo) => {
      if (response) {
        this.profile.spouseInInfos.push(response);
      }
    });
  }
  getSpouseOutInfo() {
    this.spouseOutInfoService.logged().subscribe((response: ISpouseOutInfo) => {
      if (response) {
        this.profile.spouseOutInfos.push(response);
      }
    });
  }

  // Trasfer-Request Only

  createTransferRequestForm() {
    this.transferRequestForm = this.fb.group({
      id: ['0'],
      financialYearId: [this.setting?.financialYearId, Validators.required],
      phaseId: [this.setting?.phaseId, Validators.required],
      profileId: [''],
      isTransfer: [false],
      isHardStation: [false]
    });
  }

  setValueTransferRequestFForm() {
    this.transferRequestForm.patchValue({
      id: this.transferRequest.id,
      financialYearId: this.transferRequest.financialYearId,
      phaseId: this.transferRequest.phaseId,
      profileId: this.transferRequest.profileId,
      isTransfer: this.transferRequest.isTransfer,
      isHardStation: this.transferRequest.isHardStation
    });
  }
  save() {
    if (this.transferRequestForm.valid) {
      this.loading = true;
      this.transferRequest = Object.assign({}, this.transferRequestForm.value);
      if (this.id) {
        this.service.updateOtherDtailsTransferRequest(this.id, this.transferRequest).subscribe((response: ITransferRequest) => {
          if (response && response.isTransfer) {
            this.transferRequest = response;
            //this.toastrService.success('transfer request updated successful');
            this.router.navigate(['/employee/transfer-request']);
          }
          else if (response && !response.isTransfer) {
            this.transferRequest = response;
            //this.toastrService.success('transfer request updated successful');
            this.router.navigate(['/employee/transfer-request']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.createOtherDetailsTransferRequest(this.transferRequest).subscribe((response: ITransferRequest) => {
          if (response && response.isTransfer) {
            this.transferRequest = response;
            //this.toastrService.success('transfer request added successful');
            this.router.navigate(['/employee/transfer-request']);
          }
          else if (response && !response.isTransfer) {
            this.transferRequest = response;
            //this.toastrService.success('transfer request added successful');
            this.router.navigate(['/employee/transfer-request']);
          }
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }
}
